// extracted by mini-css-extract-plugin
module.exports = {"container":"SignUpForm_container__28fPt","form":"SignUpForm_form__1UHT5"};